import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getFeatures = createAsyncThunk(
  "features/getFeatures",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/features?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createFeature = createAsyncThunk(
  "features/createFeature",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/features`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateFeature = createAsyncThunk(
  "features/updateFeature",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/features/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteFeature = createAsyncThunk(
  "features/deleteFeature",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/features/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const featuresSlice = createSlice({
  name: "features",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFeatures.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getFeatures.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getFeatures.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createFeature.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createFeature.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createFeature.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateFeature.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateFeature.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateFeature.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteFeature.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteFeature.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteFeature.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default featuresSlice.reducer;